import React from "react";

const ThankYouPage = () => {
  return (
    <div id="contactUs">
      {/* Subpage Banner */}
      <div className="container-fluid">
        <div className="row subpage-banner text-center">
          <div className="col">
            <div>
              <h1>Thank You</h1>
            </div>
            <div className="auto-h3"></div>
          </div>
        </div>
      </div>

      <div className="container mt-3 text-center">
        <div className="row auto-h4 mb-3">
          <div className="col">
            <div className="mt-2 mb-4">
              <img
                src="./images/support.svg"
                className="img-fluid icon-height-md"
                alt="customer support icon"
              />
            </div>
            <div className="auto-h3 font-weight-bold">
              Our AutoCheck Customer Support Team is dedicated to serving you and will review your request soon.
            </div>
            <div className="mt-4 mb-4">
              Please check your email for a case number to reference and future follow-up regarding your request.
            </div>
            <div className="mt-4 mb-4">
              Our hours are{" "}
              <span className="font-weight-bold">
                Monday through Friday from 8:00 a.m. to 5:00 p.m. Central Time.
              </span>{" "}
              We strive to serve you as quickly as possible.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;